module.exports = __webpack_public_path__ + "static/media/talent-benefit-easy@2x.faedf818.png";